import React from 'react';
import { useHistory } from 'react-router-dom';
import text from '../../../text';
import { isJobPayable } from '../../../utilities/job';
import { isMembershipPriceId } from '../../../utilities/membership';
import {
  isStaff,
  isUserGovernment,
  isUserUnderTrial,
} from '../../../utilities/user';
// import ConfirmationStep from './ConfirmationStep';
// import MembershipStep from './MembershipStep';
// import OrderWizardPaymentMethod from './OrderWizardPaymentMethod';
// import ProjectDetailsStep from './ProjectDetailsStep';

// Single source of truth for all order steps
export const ORDER_STEPS = {
  CART: 'cart',
  MEMBER: 'member',
  PROJECT_DETAILS: 'projectDetails',
  PAYMENT_METHOD: 'paymentMethod',
  CONFIRMATION: 'confirmation',
};

// Array of all step keys in order
export const ORDER_STEPS_SEQUENCE = [
  ORDER_STEPS.CART,
  ORDER_STEPS.MEMBER,
  ORDER_STEPS.PROJECT_DETAILS,
  ORDER_STEPS.PAYMENT_METHOD,
  ORDER_STEPS.CONFIRMATION,
];

const RedirectBack = () => {
  const history = useHistory();
  React.useEffect(() => {
    history.goBack();
  }, [history]);
  return null;
};

export const createOrderSteps = ({
  isBreakpointEnabled,
  membershipPriceId,
  paymentMethodId,
  currentUser,
  job,
  hasValidMembership,
  dispatch,
  setMembershipPriceId,
  setPaymentMethodId,
  handlePreviousStepClicked,
}) => {
  return [
    {
      key: ORDER_STEPS.CART,
      component: <RedirectBack />,
      name: text(ORDER_STEPS.CART),
    },
    {
      key: ORDER_STEPS.MEMBER,
      component: null,
      name: text(ORDER_STEPS.MEMBER),
      filter: () => {
        return (
          !process.env.DISABLE_STRIPE &&
          !isUserGovernment(currentUser) &&
          !isStaff(currentUser.role) &&
          (!hasValidMembership || isUserUnderTrial(currentUser))
        );
      },
    },
    {
      key: ORDER_STEPS.PROJECT_DETAILS,
      component: null,
      name: text(ORDER_STEPS.PROJECT_DETAILS),
    },
    {
      key: ORDER_STEPS.PAYMENT_METHOD,
      component: null,
      name: text(ORDER_STEPS.PAYMENT_METHOD),
      filter: () =>
        !isStaff(currentUser.role) &&
        (isJobPayable(job) || isMembershipPriceId(membershipPriceId)),
      disabled: !job?.project?.name,
    },
    {
      key: ORDER_STEPS.CONFIRMATION,
      component: null,
      name: text(ORDER_STEPS.CONFIRMATION),
      disabled: !job?.project?.name && !paymentMethodId,
      // filter: () => !isRequestQuote,
    },
  ];
};

export const filterAvailableSteps = (orderSteps) => {
  return orderSteps.filter((step) => (step.filter ? step.filter() : true));
};

/**
 * Get step name by order/index
 * @param {number} index - The step index (0-based)
 * @param {boolean} isMemberStepExcluded - Whether to exclude the member step from the sequence
 * @returns {string|null} - The step name or null if index is invalid
 */
export const getStepNameByIndex = (index, isMemberStepExcluded = false) => {
  const stepSequence = isMemberStepExcluded
    ? ORDER_STEPS_SEQUENCE.filter((step) => step !== ORDER_STEPS.MEMBER)
    : ORDER_STEPS_SEQUENCE;

  if (index >= 0 && index < stepSequence.length) {
    return stepSequence[index];
  }
  return null;
};
